<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-investor-change bizcomp ' + className">
            <div class="title-box">
                <span class="title">{{ title }}</span>
                <span class="tip">
                    我要了解
                    <span class="content" v-on:click.prevent="otherVisible = true">
                        普通投资者与专业投资者之间的区别>
                    </span>
                </span>
            </div>
            <el-row class="investor">
                <el-col :span="24" class="investor-change-tit">
                    <div class="investor-box cate">
                        <i class="investor-now" :class="{ pro: cate === '1' }" aria-hidden="true" />
                        <div class="investor-mes">
                            <span class="tit">您现在的投资者类型是</span>
                            <span class="mes">{{ cateVal }}</span>
                        </div>
                    </div>
                    <div class="investor-box">
                        <i class="investor-now" :class="{ ord: cate === '1' }" aria-hidden="true" />
                        <div class="investor-mes">
                            <span class="tit">可转换为</span>
                            <span class="mes">
                                {{ (cate === "1" ? "普通" : "专业") + "投资者" }}
                                <span v-if="innvestorInfo.status === '1'" class="red">
                                    （正在审核中）
                                </span>
                            </span>
                        </div>
                    </div>
                </el-col>
                <el-col v-if="cate === '0'" :span="24" class="investor-info">
                    <p class="tit">
                        *符合下列条件之一的普通投资者可以申请转化成为专业投资者，但经营机构有权自主决定是否同意其转化
                    </p>
                </el-col>
                <el-table
                    v-if="cate === '0'"
                    :data="tableData"
                    style="width: 100%; color: #333333"
                    border
                    :show-header="false"
                    :span-method="mergeCell"
                >
                    <el-table-column prop="title" width="200"></el-table-column>
                    <el-table-column prop="text" width="260"></el-table-column>
                    <el-table-column prop="value"></el-table-column>
                </el-table>
                <el-col :span="24" class="assets-info">
                    <p v-if="cate === '0'" class="note">
                        *前款所称金融资产，是指银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货及其他衍生产品等。
                    </p>
                    <p v-else class="note">
                        *金融资产是指银行存款、股票、债券、基金、份额、资产管理计划、银行理财产品、信托计划、保险产品、期货及其他行生品等。
                    </p>
                </el-col>
                <el-col
                    v-if="innvestorInfo.status == '0' || innvestorInfo.status == ''"
                    class="investor-form two-cols-form"
                    :span="24"
                >
                    <el-form
                        v-if="cate === '0'"
                        ref="innvestorInfo"
                        :model="innvestorInfo"
                        :rules="rules"
                        label-width="160px"
                        class="acct-form"
                        size="small"
                        v-on:submit.native.prevent
                    >
                        <el-col :span="12" style="margin-right: 500px">
                            <el-form-item label="客户全称：">
                                <div class="text-con">
                                    {{ innvestorInfo.custname }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="$cache.getUser().certificatetype" :span="12">
                            <el-form-item label="证件类型：" class="form-text">
                                <div class="text-con">
                                    {{ $cache.getDict("130007", $cache.getUser().certificatetype) }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="$cache.getUser().certificateno" :span="12">
                            <el-form-item label="证件号码：">
                                <div class="text-con">
                                    {{ $cache.getUser().certificateno }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="金融资产："
                                prop="perfinancialassets"
                                class="required"
                            >
                                <el-input
                                    v-model.trim="innvestorInfo.perfinancialassets"
                                    placeholder="请输入金融资产"
                                    maxlength="8"
                                    style="width: 400px"
                                    class="text-con"
                                >
                                    <div slot="suffix" class="text-con unit">万元</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="近三年年均收入："
                                prop="peravgincome"
                                class="required"
                            >
                                <el-input
                                    v-model.trim="innvestorInfo.peravgincome"
                                    placeholder="请输入近三年年均收入"
                                    :maxlength="8"
                                    style="width: 400px"
                                    class="text-con"
                                >
                                    <div slot="suffix" class="text-con unit">万元</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="投资经历：" prop="perinvestexp" class="required">
                                <el-input
                                    v-model.trim="innvestorInfo.perinvestexp"
                                    placeholder="请输入投资经历"
                                    :maxlength="2"
                                    style="width: 400px"
                                    class="text-con"
                                >
                                    <div slot="suffix" class="text-con unit">&nbsp;年</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="投资工作经历："
                                prop="perinvestwork"
                                class="required"
                            >
                                <el-input
                                    v-model.trim="innvestorInfo.perinvestwork"
                                    placeholder="请输入投资工作经历"
                                    :maxlength="2"
                                    style="width: 400px"
                                    class="text-con"
                                >
                                    <div slot="suffix" class="text-con unit">年</div>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="相关从事职业："
                                prop="perinvesttype"
                                class="required"
                            >
                                <el-select
                                    v-model.trim="innvestorInfo.perinvesttype"
                                    filterable
                                    placeholder="请选择"
                                    style="width: 400px"
                                >
                                    <el-option
                                        v-for="item in perinvesttypes"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="isPwdCheck" :span="12">
                            <el-form-item label="交易密码：" prop="tradepwd" class="required">
                                <el-input
                                    v-model.trim="innvestorInfo.tradepwd"
                                    placeholder="请输入交易密码"
                                    :maxlength="20"
                                    style="width: 400px"
                                    type="password"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="agree-box">
                                <el-checkbox v-model="isAgree" size="mini"></el-checkbox>
                                <span class="agree-text">
                                    本人已了解基金公司对专业投资者和普通投资者在履行投资者适当性职责方面的差别，确认自主承担可能产生的风险和后果，并按要求提供相关证明材料，自愿转换为【专业投资者】
                                </span>
                            </div>
                        </el-col>
                    </el-form>
                    <el-col :span="24" class="btn-group">
                        <el-button class="medium footer-button cancel" v-on:click="$router.back()">
                            返回
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium ooter-button apply"
                            v-on:click="submitInfo('innvestorInfo')"
                        >
                            申请转换
                        </el-button>
                    </el-col>
                </el-col>
            </el-row>
            <!--弹窗提示-->
            <!--投资者转换风险警示-->
            <el-dialog
                v-if="cate === '0'"
                title="投资者转换风险警示"
                :visible.sync="dialogVisible"
                class="prop info-tips"
                width="880px"
            >
                <div class="investor-tips">
                    <el-alert
                        title="您已达到专业投资者条件，请阅读风险警示选择是否继续转换"
                        type="warning"
                        show-icon
                        :closable="false"
                    />
                    <div class="investor-info">
                        <p class="list">
                            本人经贵司认定为普通投资者，经本人审慎考虑，现决定自愿申请转化为贵司的专业投资者。本人已充分理解专业投资者与普通投资者的区别。
                        </p>
                        <p class="list">
                            包括但不限于履行投资者适当性义务差别、投资风险的差别等。转化为专业投资者后，将自主承担可能产生的风险和后果。本人承诺所提供材料真实、准确、完整。
                        </p>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button v-on:click="dialogVisible = false">暂不转换</el-button>
                    <el-button type="primary" v-on:click="agreeToProfessional">
                        我已阅知风险，并同意继续转换为专业投资者
                    </el-button>
                </div>
            </el-dialog>
            <!--投资者转换提示-->
            <el-dialog
                title="投资者转换提示"
                :visible.sync="investorVisible"
                class="prop"
                width="420px"
                :show-close="false"
            >
                <div class="info-box">
                    <el-alert :title="changeMsg" type="warning" show-icon :closable="false" />
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button v-if="btnMsg" v-on:click.once="$router.back()">返回</el-button>
                    <el-button v-else type="primary" v-on:click.prevent="investorVisible = false">
                        取消
                    </el-button>
                    <el-button v-if="btnMsg" type="primary" v-on:click.prevent="again">
                        {{ btnMsg }}
                    </el-button>
                </div>
            </el-dialog>
            <!--普通投资者与专业投资者之间的区别-->
            <el-dialog
                title="普通投资者与专业投资者之间的区别"
                :visible.sync="otherVisible"
                class="prop"
                width="1220px"
            >
                <div class="difference-box">
                    <el-table
                        :data="differenceData"
                        style="width: 100%; color: #333333"
                        border
                        :show-header="false"
                    >
                        <el-table-column prop="title" width="200"></el-table-column>
                        <el-table-column prop="text"></el-table-column>
                        <el-table-column>
                            <template slot-scope="scope">
                                <span v-if="scope.row.prefix" class="prefix">
                                    {{ scope.row.prefix }}
                                </span>
                                <span>{{ scope.row.value }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" v-on:click.prevent="otherVisible = false">
                        我知道了
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";

export default {
    name: "InvestorChange",
    mixins: [mixin],
    data() {
        return {
            tableData: [
                {
                    title: "自然人",
                    text: "金融资产或年均收入",
                    value: "金融资产不低于 300 万元或者最近 3年个人年均收入不低于 30 万元"
                },
                {
                    title: "",
                    text: "最近 1 年末金融资产",
                    value: "1 年以上证券、基金、期货、黄金、外汇等投资经历或者 1年以上金融产品设计、投资、风险管理及相关工作经历"
                }
            ],
            dialogVisible: false,
            investorVisible: false,
            otherVisible: false,
            cate: "",
            cateVal: "",
            innvestorInfo: {},
            perinvesttypes: [
                {
                    subitem: "0",
                    subitemname: "未从事相关职业"
                },
                {
                    subitem: "1",
                    subitemname: "专业投资者的高级管理人员、从事金融相关业务的注册会计师或律师"
                }
            ],
            changeMsg: "",
            isPwdCheck: false,
            btnMsg: "",
            query: null,
            rules: {
                perfinancialassets: [
                    { required: true, message: "请输入金融资产", trigger: "blur" }
                ],
                perinvesttype: [
                    { required: true, message: "请选择相关从事职业", trigger: "change" }
                ],
                peravgincome: [
                    { required: true, message: "请输入近三年年均收入", trigger: "blur" }
                ],
                perinvestexp: [{ required: true, message: "请输入投资经历", trigger: "blur" }],
                perinvestwork: [{ required: true, message: "请输入投资工作经历", trigger: "blur" }],
                tradepwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            needtest: "",
            isAgree: false,
            differenceData: []
        };
    },
    watch: {
        cate(val) {
            this.cateVal = this.$cache.getDict("120051", val);
        },
        "innvestorInfo.perfinancialassets"(val) {
            this.mustNum(val, "perfinancialassets");
        },
        "innvestorInfo.peravgincome"(val) {
            this.mustNum(val, "peravgincome");
        },
        "innvestorInfo.perinvestexp"(val) {
            this.mustNum(val, "perinvestexp");
        },
        "innvestorInfo.perinvestwork"(val) {
            this.mustNum(val, "perinvestwork");
        }
    },
    created() {
        // 重新提取最小日期
        // this.perinvesttypes = this.$cache.getDict("100011");
        // this.isPwdCheck = this.$cache.getPwdCheck("P2");
        this.getInvestor();
        this.assignDifferenceData();
    },
    methods: {
        // 合并单元格
        mergeCell({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            const _this = this;
            if (_this.cate === "1") {
                //  专业转普通
                _this.professional2ordinary();
                return;
            }
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 普通转专业 判断是否符合转换成专业投资者条件
                    _this.acctChangetypeCheck();
                } else {
                    _this.$errorScroll();
                }
            });
        },

        // 判断是否符合转换成专业投资者条件
        async acctChangetypeCheck() {
            if (!this.isAgree) {
                this.$message({
                    type: "warning",
                    message: "请勾选自愿转换协议"
                });
                return;
            }
            const params = {
                custtype: "3",
                perfinancialassets: this.innvestorInfo.perfinancialassets * 10000,
                peravgincome: this.innvestorInfo.peravgincome * 10000,
                perinvestexp: this.innvestorInfo.perinvestexp,
                perinvestwork: this.innvestorInfo.perinvestwork,
                perinvesttype: this.innvestorInfo.perinvesttype,
                invtp: "1"
            };
            const res = await userApi.acctChangetypeCheck(params);
            if (res.data) {
                if (res.data.assetcheckresult && res.data.assetcheckresult !== "0") {
                    // this.dialogVisible = true;
                    this.needtest = res.data.needtest;
                    this.assignChangeParams();
                    this.agreeToProfessional();
                } else {
                    this.changeMsg = "您还未达到专业投资者条件，无法进行转换";
                    this.btnMsg = "";
                    this.investorVisible = true;
                }
            }
        },

        // 组装普通转专业请求参数
        assignChangeParams() {
            const data = {
                oldprofessionflag: "0",
                professionflag: "1",
                professionleel: "3",
                opertype: "转换",
                custtype: "11",
                attachmentflag: "1",
                netassetsisover1000: "0",
                financialassetsisover500: "0",
                perinvestexpisover1: Number(this.innvestorInfo.perinvestexp) >= 1 ? "1" : "0",
                perfinancialassetsisover300:
                    Number(this.innvestorInfo.perfinancialassets) >= 300 ? "1" : "0",
                acceptmethod: this.$util.getConfig().systemtype,
                peravgincomeisover30: Number(this.innvestorInfo.peravgincome) >= 30 ? "1" : "0",
                perinvestworkisover1: Number(this.innvestorInfo.perinvestwork) >= 1 ? "1" : "0",
                custname: this.innvestorInfo.custname
            };
            this.$store.commit("updateChangeParams", data);
        },

        // 专业转普通
        async professional2ordinary() {
            const res = await userApi.professional2Ordinary({
                oldprofessionflag: "1",
                professionflag: "0",
                acceptmethod: this.$util.getConfig().systemtype
            });
            if (res.data) {
                let msg = "";
                this.$cache.refreshUser();
                msg = "您已成功从专业投资者转换为普通投资者";
                // if (res.data.confirmflag === "1") {

                // } else {
                //     msg = "您已成功发起专业投资者转换为普通投资者申请，审核通过后将转为普通投资者";
                // }
                const _this = this;
                const message1 = msg + "，";
                const message2 = "秒后回到个人信息页面";
                _this.$handleAutoCloseMessage({
                    type: "success",
                    message1: message1,
                    message2: message2,
                    number: 3,
                    onClose: function () {
                        _this.$router.push({ name: "acctManager" });
                    }
                });
            } else {
                this.$message({
                    type: "error",
                    message: res.msg
                });
            }
        },

        // 是否上传转换文件
        again() {
            if (this.innvestorInfo.status === "2") {
                this.investorVisible = false;
                this.$router.push({ name: "invdataup" });
            } else if (this.innvestorInfo.status === "3") {
                this.investorVisible = false;
            } else {
                this.investorVisible = false;
                this.$router.back();
            }
        },
        // 转换为专业投资者
        agreeToProfessional() {
            if (this.needtest == "0") {
                this.$router.push({ name: "invdataup" });
            } else {
                this.$router.push({ name: "invknowledgetest" });
                // if (this.$cache.getSysParam("600040") == "3") {
                //     this.$router.push({ name: "invknowledgetest" });
                // }
            }
        },
        // 获取投资者转换信息
        getInvestor() {
            this.$util.getProfession((data) => {
                this.innvestorInfo = data;
                // if (this.innvestorInfo.status === "2") {
                //     this.changeMsg = "您还没有提交投资者转换所需文件资料，请前往提交";
                //     this.btnMsg = "前往提交";
                //     this.investorVisible = true;
                // }
                // if (this.innvestorInfo.status === "3") {
                //     this.changeMsg = "您的投资者转换申请审核失败，" + this.innvestorInfo.failedreason;
                //     this.btnMsg = "重新申请";
                //     this.investorVisible = true;
                // }
                this.cate = this.innvestorInfo.professionflag;
                // this.isPwdCheck = this.cate === "0" ? this.$cache.getPwdCheck("P2") : this.$cache.getPwdCheck("P1");
                const _x = this.$cache.getUser();
                _x.professionflag = this.cate;
                _x.effectdate = this.innvestorInfo.effectdate;
                this.$store.dispatch("setInfo", _x);
            });
        },
        // 只能输入数字
        mustNum(val, param) {
            const _x = this.$util.filterNum(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.innvestorInfo, param, _x);
            }, 1);
        },
        // 普通投资者与专业投资者区别
        assignDifferenceData() {
            this.differenceData = [
                {
                    title: "",
                    text: "专业投资者（符合下列条件之一即可）",
                    value: "普通投资者",
                    prefix: ""
                },
                {
                    title: "是否为金融机构",
                    text: "经有关金融监管部门批准设立的金融机构，包括证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司等；经行业协会备案或者登记的证券公司子公司、期货公司子公司、私募基金管理人。",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "是否为面向投资者发行的理财产品",
                    text: "上述机构面向投资者发行的理财产品，包括但不限于证券公司资产管理产品、基金管理公司及其子公司产品、期货公司资产管理产品、银行理财产品、保险产品、信托产品、经行业协会备案的私募基金",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "同时符合下列条件的法人或其他组织",
                    text: "1、 最近 1 年末净资产不低于 2000 万元2、 最近 1 年末金融资产不低于 1000 万元3、具有 2 年以上证券、基金、期货、黄金、外汇等投资经历",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "同时符合下列条件的自然人",
                    text: "1、 金融资产不低于 500 万元，或者最近 3 年个人年均收入不低于 50 万元2、 具有 2 年以上证券、基金期货、黄金、外汇等投资经历，或者具有 2 年以上金融产品设计、投资、风险管理及相关工作经历3、 金融机构高级管理人员、获职业资格认证的从事金融相关业务的注册会计师和律师",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "是否在信息告知享有特别保护",
                    text: "不限制",
                    value: "1、可能直接导致本金亏损的事项2、 可能直接导致超过原始本金亏损的事项 3、因经营机构的业务或者财务状况变化，可能导致本金或者原始本金亏损的事项 4、因经营机构的业务或者财务状况变化，影响客户判断的重要事由5、限制销售对象权利行使期限或者可解除合同期限等全部限制内容",
                    prefix: "应告知："
                },
                {
                    title: "是否在风险警示、适当性匹配等方面享有特别保护",
                    text: "不限制",
                    value: "1、向不符合准入要求的投资者销售产品或者提供服务2、向投资者就不确定事项提供确定性的判断，或者告知投资者有可能使其误认为具有确定性的意见3、向普通投资者主动推介风险等级高于其风险承受能力的产品或者服务4、向普通投资者主动推介不符合其投资目标的产品或者服务 5、向风险承受能力最低类别的投资者销售或者提供风险等级高于其风险承受能力的产品或者服务 6、其他违背适当性要求，损害投资者合法权益的行为",
                    prefix: "禁止经营机构进行下列销售产品或者提供服务的活动："
                }
            ];
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/*用户信息 */
.bizcomp-investor-change {
    /* 为表格中的所有行添加hover效果 */
    .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
        background-color: transparent !important;
    }
    .el-table--fit {
        margin-bottom: 0;
    }
    .dialog-footer {
        text-align: center;
    }
    .title-box {
        display: flex;
        align-items: flex-end;
        margin: 0 20px;
        padding: 20px 0;
        border-bottom: 1px solid #f1f1f1;
        .title {
            font-size: 20px;
            font-weight: 500;
            color: #333333;
        }
        .tip {
            margin-left: 9px;
            font-size: 14px;
            font-weight: normal;
            margin-bottom: 2px;
            color: #999999;
            .content {
                color: #1890ff;
                cursor: pointer;
            }
        }
    }
    .investor {
        padding: 30px 20px 20px;
        .investor-change-tit {
            border: 1px solid #f1f1f1;
            padding: 30px 0;
            text-align: center;
            .investor-box {
                display: inline-block;
                vertical-align: middle;
                &:first-of-type:after {
                    content: "";
                    width: 46px;
                    height: 15px;
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 40px;
                    background: url($investor) -139px -15px no-repeat;
                }
                &.cate {
                    .investor-now {
                        background: $color-b url($investor) 15px 11px no-repeat;
                        &.pro {
                            background: $color-b url($investor) -58px 11px no-repeat;
                        }
                    }
                    .investor-mes {
                        .tit {
                            color: $text-color1;
                        }
                        .mes {
                            color: $color-b;
                        }
                    }
                }
                .investor-now {
                    width: 64px;
                    height: 64px;
                    background: #d6d6d6 url($investor) -58px 11px no-repeat;
                    display: inline-block;
                    border-radius: 100%;
                    vertical-align: middle;
                    &.ord {
                        background: #d6d6d6 url($investor) 15px 11px no-repeat;
                    }
                }
                .investor-mes {
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 12px;
                    text-align: left;
                    .tit {
                        color: $text-color3;
                        font-size: $f16;
                        line-height: 30px;
                        display: block;
                    }
                    .mes {
                        color: $text-color1;
                        font-size: $f22;
                        line-height: 30px;
                        display: block;
                        .red {
                            color: $color-c;
                        }
                    }
                }
            }
        }
        .investor-form {
            margin-top: 16px;
            .text-con {
                font-size: 16px;
                color: #1a1a1a;
            }
        }
    }
    .investor-info {
        background: #f9f9f9;
        border: 1px solid #f1f1f1;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        padding: 20px;
        .tit {
            color: #333333;
            font-size: 14px;
        }
        .list {
            color: $text-color1;
            line-height: 24px;
            span {
                color: $color-c;
            }
        }
        .note {
            &:before {
                content: "*";
                color: $color-c;
            }
            color: $text-color3;
            line-height: 24px;
        }
    }
    .assets-info {
        padding: 12px 16px;
        border: 1px solid #f1f1f1;
        .note {
            color: #fd6112;
        }
    }
    .footer-button {
        width: 180px;
        height: 42px;
        border-radius: 2px;
    }
    .footer-button:hover {
        border: none;
    }
    .cancel {
        color: #666666;
        background: #e4e4e4;
    }
    .apply {
        color: #ffffff;
        background: var(--color-primary);
    }
    .el-input__inner {
        height: 40px;
    }
    .unit {
        width: 56px;
        line-height: 40px;
    }
    .unit::before {
        content: "";
        position: absolute;
        left: 0px;
        width: 1px;
        height: 100%;
        background-color: #d9d9d9;
    }
    .el-select .el-input__inner {
        font-size: 16px;
        color: #1a1a1a;
    }
    .agree-box {
        display: flex;
        gap: 5px;
        margin-top: 25px;
        .el-checkbox__inner {
            width: 18px;
            height: 18px;
        }
        .agree-text {
            margin-top: -3px;
            font-size: 14px;
            font-weight: normal;
            letter-spacing: 0;
            line-height: 26px;
            color: var(--color-primary);
        }
    }
    .difference-box {
        padding: 20px 30px 10px;
        .prefix {
            font-weight: 700;
        }
    }
}
</style>
